import React, { useEffect, useState } from "react";
import api from "../../utils/api";
import Layout from "../../components/layout/DefaultLayout";
import "../../styles/assessmentlist.css";
import { useNavigate } from "react-router-dom";

const AssessmentList = () => {
    const [assessments, setAssessments] = useState([]);
    const [selectedAssessment, setSelectedAssessment] = useState(null);

    const [classes, setClasses] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [chapters, setChapters] = useState([]);

    const username = sessionStorage.getItem("username");
    const navigate = useNavigate();


    useEffect(() => {
        if (username) {
            api.get(`/assessment-courses?createdBy=${username}`).then(res => {
                setAssessments(res.data);
            });

            api.get("/class-standards").then(res => setClasses(res.data));
            api.get("/subjects").then(res => setSubjects(res.data));
            api.get("/chapters").then(res => setChapters(res.data));
        }
    }, [username]);

    const resolveNames = (idsString, sourceList) => {
        if (!idsString) return [];
        const ids = idsString.split(",").map(id => id.trim());
        return sourceList
            .filter(item => ids.includes(String(item.id)))
            .map(item => item.name);
    };

    const formatPreviewList = (items) => {
        if (!items || items.length === 0) return "None";
        if (items.length <= 2) return items.join(", ");
        return (
            <span className="preview-multivalue">
                {items.slice(0, 2).join(", ")},{" "}
                <span className="preview-tooltip-wrapper">
                    <span className="preview-tooltip-trigger">+{items.length - 2} more</span>
                    <div className="preview-tooltip-box">
                        <ul>
                            {items.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </span>
            </span>
        );
    };

    const handleStartAssessment = (assessment, isQuestionPaperView) => {
        const subjectNames = resolveNames(assessment.subjectIds, subjects);
        const chapterNames = resolveNames(assessment.chapterIds, chapters);

        navigate(!isQuestionPaperView ? "/assessment" : "/questionpaper", {
            state: {
                ...assessment
            }
        });
    };

    const handleDeactivate = async () => {
        if (!selectedAssessment) return;

        try {
            const updated = {
                ...selectedAssessment,
                isActive: false,
                updatedBy: username,
                updatedAt: new Date().toISOString()
            };

            await api.put(`/assessment-courses/${selectedAssessment.id}`, updated);

            // Remove from list or mark as inactive
            setAssessments(prev => prev.filter(a => a.id !== selectedAssessment.id));
            setSelectedAssessment(null);
        } catch (error) {
            console.error("Failed to deactivate assessment:", error);
            alert("Could not deactivate the assessment. Please try again.");
        }
    };


    return (
        <Layout>

            <div className="assessment-list-wrapper">

                <div className="assessment-list-panel">
                    <div className="assessment-list-header">
                        <h3>📚 Your Assessment Courses</h3>

                        <button className="button button-primary" onClick={() => navigate("/assessment-setup")}>
                            Create New Assessment
                        </button>
                    </div>

                    <ul className="assessment-list">
                        {assessments.map(assessment => (
                            <li
                                key={assessment.id}
                                className={selectedAssessment?.id === assessment.id ? "active" : ""}
                            >
                                <div className="assessment-item-header" onClick={() => setSelectedAssessment(assessment)}>
                                    {assessment.courseName}
                                </div>
                                <button
                                    className="start-btn"
                                    onClick={() => handleStartAssessment(assessment, true)}
                                >
                                    View Question Paper
                                </button>
                                <button
                                    className="start-btn"
                                    onClick={() => handleStartAssessment(assessment, false)}
                                >
                                    Start Assessment
                                </button>
                            </li>

                        ))}
                    </ul>
                </div>

                <div className="assessment-preview-panel">
                    {selectedAssessment ? (
                        <>
                            <h4>🧾 Preview</h4>
                            <ul className="preview-list">
                                <li>
                                    <strong>Course:</strong> {selectedAssessment.courseName}
                                </li>
                                <li>
                                    <strong>Class:</strong>{" "}
                                    {classes.find(c => String(c.id) === String(selectedAssessment.classId))?.name || selectedAssessment.classId}
                                </li>
                                <li>
                                    <strong>Subjects:</strong>{" "}
                                    {formatPreviewList(resolveNames(selectedAssessment.subjectIds, subjects))}
                                </li>
                                <li>
                                    <strong>Chapters:</strong>{" "}
                                    {formatPreviewList(resolveNames(selectedAssessment.chapterIds, chapters))}
                                </li>
                                <li>
                                    <strong>Difficulty:</strong>{" "}
                                    {formatPreviewList(selectedAssessment.difficultyLevels?.split(",") || [])}
                                </li>
                                <li>
                                    <strong>Question Types:</strong>{" "}
                                    {formatPreviewList(selectedAssessment.questionTypes?.split(",").map(q => q.replace(/_/g, " ")) || [])}
                                </li>
                                <li>
                                    <strong>Questions:</strong> {selectedAssessment.numberOfQuestions}
                                </li>
                                <li>
                                    <strong>Timer:</strong> {selectedAssessment.timerDuration} min
                                </li>
                            </ul>

                            <div className="preview-actions">
                                <button
                                    className="button button-primary"
                                    onClick={handleDeactivate}
                                >
                                    Deactivate
                                </button>

                                <button
                                    className="button button-secondary"
                                    onClick={() => navigate(`/assessment-setup?id=${selectedAssessment.id}`)}
                                >
                                    Modify Assessment Course
                                </button>



                            </div>


                        </>
                    ) : (
                        <p className="empty-preview">Select an assessment to view details.</p>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default AssessmentList;
